import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ownedBy: {
		id: 'issue-navigator-custom-filters.details-popup.popup-content.owner.owned-by',
		defaultMessage: 'Owned by {linkStart}{ownerName}{linkEnd}',
		description: 'Sentence describing which user owns the filter',
	},
});
